/**
 * Session display helpers — the ONE place the card/list/dialog title fallback
 * lives ("topic, else raw title, else the localised new-conversation label").
 * Before this helper the chain was hand-copied across six components and the
 * fallback key had already forked (home.newConversation vs
 * session.newConversation, with diverging German copy).
 */
import type { TFunction } from 'i18next';

/** The minimal shape needed — every session response type satisfies it. */
export interface TitledSession {
  topic?: string | null;
  title?: string | null;
}

export function sessionDisplayTitle(session: TitledSession, t: TFunction): string {
  return (
    session.topic || session.title || t('session.newConversation', 'Neues Gespräch')
  );
}
